import React from "react";
import { BookOpen, ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import Footer from "../Footer/Footer";
import "./Resources.css";

/**
 * Resources — /resources
 *
 * DEVIATION (flagged): this page previously rendered four article cards whose
 * every field was placeholder — "Title of content comes here", four identical
 * Lorem ipsum paragraphs, a hardcoded "Dec 3, 2024" byline, and a "Read more..."
 * link that went nowhere. Its stylesheet was an empty file, so none of it was
 * styled either. It was reachable on a live route from the footer.
 *
 * Shipping Lorem ipsum to real users is worse than shipping an honest empty
 * state, so the placeholder articles are gone and this is now a proper
 * "nothing here yet" page that points people at the routes that do have
 * content. When real articles exist, restore the card grid — the CSS for it is
 * already in Resources.css under RESOURCE CARDS.
 */
const Resources = () => {
  return (
    <div className="ds-marketing resources-page">
      <div className="resources-hero">
        <div className="resources-hero-inner">
          <span className="resources-tag">Knowledge base</span>
          <h1 className="resources-title">Resources</h1>
          <p className="resources-subtitle">
            Guides and explainers on property verification, master plans and land
            records.
          </p>
        </div>
      </div>

      <div className="resources-body">
        <div className="resources-empty">
          <span className="resources-empty__icon" aria-hidden="true">
            <BookOpen />
          </span>
          <h2 className="resources-empty__title">No articles published yet</h2>
          <p className="resources-empty__body">
            We&rsquo;re preparing guides on property verification, city master plans
            and land records. In the meantime, these pages cover the essentials.
          </p>
          <div className="resources-empty__actions">
            <NavLink to="/ourProcess" className="resources-empty__btn resources-empty__btn--primary">
              How verification works
              <ArrowRight size={16} aria-hidden="true" />
            </NavLink>
            <NavLink to="/faq" className="resources-empty__btn">
              Read the FAQs
            </NavLink>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Resources;
